import React from 'react';
import clsx from 'clsx';
import styles from '../FundingHistory.module.scss';
import { downloadDarkGray } from '../../../../../../../assets/hostedassets';
import LoadingSpinner from '../../../../../../../common/_custom/LoadingSpinner/LoadingSpinner';

interface FundingTableRowProps {
    data: any;
    headers: Array<{ id: string; label: string }>;
    rowIndex: number;
    isPDFReport: boolean;
    onDownload?: (docId: string, rowIndex: number) => void;
    isDownloading?: boolean;
}

function FundingTableRow({ data, headers, rowIndex, isPDFReport, onDownload, isDownloading = false }: FundingTableRowProps) {
    const getRowItem = (headerId: string, fundingData: any, rowIndex: number) => {
        switch (headerId) {
            case 'docId':
                return fundingData?.docId ? (
                    <div className={styles.DocIconContainer}>
                        {isDownloading ? (
                            <LoadingSpinner height={'16px'} color={'#6021b3'} style={{ margin: 0, padding: 0 }} />
                        ) : (
                            <div className={styles.DownloadContainer}>
                                <img
                                    alt={'download'}
                                    className={styles.DownloadIcon}
                                    src={downloadDarkGray}
                                    height={'14.5px'}
                                    onClick={() => onDownload?.(fundingData?.docId, rowIndex)}
                                />
                            </div>
                        )}
                    </div>
                ) : null;
            default:
                return fundingData?.[headerId] ?? '-';
        }
    };

    return (
        <div className={styles.tableRow}>
            {headers.map((header) => (
                <div
                    key={header.id}
                    className={clsx(styles.rowItem, {
                        [styles.alignRight]: ['fundingAmount'].includes(header.id),
                    })}
                >
                    {getRowItem(header.id, data, rowIndex)}
                </div>
            ))}
        </div>
    );
}

export default FundingTableRow;
